import { render, staticRenderFns } from "./aboutIcu.vue?vue&type=template&id=906d93a8&scoped=true&"
import script from "./aboutIcu.vue?vue&type=script&lang=js&"
export * from "./aboutIcu.vue?vue&type=script&lang=js&"
import style0 from "./aboutIcu.vue?vue&type=style&index=0&id=906d93a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "906d93a8",
  null
  
)

export default component.exports